import { defineStore } from "pinia";
import axios from "axios";
/*
已完成：
2 3 4 5 6  | 7 9 10 12 13 | 14 15 
未做：
1(计划外按顺序插入访视期中) 
8（文件预览（pdf、excel、word））
11（先不做）

13 14 （待确定）


排序，要 传医生id，医院id（两种情况）


*/


const env = import.meta.env;

export const useApiStore = defineStore("api", {
  state: () => ({
    // 获取最新版本号
    getLastVersion: () => {
      return axios({
        url: env.VITE_APP_API_LAST_VERSION_URL,
        method: "get",
        params: {
          random: Math.random()
        }
      });
    },
  })
});
